import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { ViewingRequestState } from '@enums';
import { useColumns } from '../viewing-request-columns';
import { useViewingRequests } from '../viewing-requests';

export function ViewingRequestsNew() {
  const intl = useIntl();

  const { columnCreated, columnEsFile, columnViewingMethod, columnRequester } =
    useColumns();

  const { evidenceBag } = useViewingRequests({
    evidenceProps: {
      tableProps: {
        columns: [
          columnCreated,
          columnEsFile,
          columnViewingMethod,
          columnRequester,
        ],
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: ViewingRequestState.NEW,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__VIEWING_REQUESTS__NEW__TABLE__TITLE',
          defaultMessage: 'Nové žádosti o nahlížení',
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
